<!--  搜索页   -->
<template>
  <div class="container">
    <div class="search_nav">
      <img class="go_back" src="@/icon/back_black.png" alt @click="go_back()">
      <div class="s_inp">
        <img src="@/assets/icon_search.png" alt="">
        <form action="javascript:return true">
          <input v-model="keywords" type="search" placeholder="搜索课程" @keyup.enter="enter_s()">
        </form>
      </div>
      <div class="ss_btn search_btn" @click="enter_s()">
        搜索
      </div>
      <div class="ss_btn" @click="go_back()">
        取消
      </div>
    </div>
    <div class="s_history">

      <div v-if="historyArr.length">
        <p class="history_p flex_box">
          <span>历史搜索</span>
          <span v-if="historyArr.length">
            <span class="close" @click="close()">
              <van-icon name="delete" />
              <span>清除</span>
            </span>
          </span>
        </p>
        <div>
          <p v-for="(item,index) in historyArr" :key="index" class="history_span" @click="search(item.content)">{{ item.content }}</p>
        </div>
      </div>
      <p class="history_p" v-if="hotArr.length">热门搜索</p>
      <div v-if="hotArr.length">
        <p v-for="(item,index) in hotArr" :key="index" class="history_span" @click="search(item.content)">{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserSearchLog,saveUserSearchLog,delUserSearchLog,getHotSearch } from '@/api/search.js'
import tool from '@/utils/tools'
export default {
  components: {

  },
  data() {
    return {
      historyArr: [],
      show_history: true,
      keywords: '',
      hotArr: []
    }
  },
  computed: {

  },
  created() {
    this.gethistory()
    this.getHotWords()
  },
  methods: {
    gethistory() {
      getUserSearchLog().then(res => {
        this.historyArr = res.result
      })
    },
    search(keywords) {
      this.$router.push({
        path: '/shopSearch',
        query: {
          search_Value: keywords
        }
      })
    },
    close() {
      // this.show_history = false
      delUserSearchLog().then((res)=>{
        if(res.errNo==0){
          this.gethistory()
          this.$toast(res.result)
        }
      })
    },
    enter_s() {
      var info = {
        content:this.keywords
      }
      saveUserSearchLog(info).then((res)=>{
        if(res.errNo==0){
          this.$router.push({
            path: '/shopSearch',
            query: {
              search_Value: this.keywords
            }
          })
        }
      })
      
    },
    getHotWords(){
      getHotSearch().then(res=>{
        if(res.errNo==0){
          this.hotArr = res.result
        }
      })
    },
    go_back() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.container{
  height: 100%;
  .search_nav{
    height: 80px;
    width: 100%;
    background: #fff;
    overflow: hidden;
    .s_inp{
      width: 60%;
      height: 50px;
      margin-top: 15px;
      margin-left: 20px;
      float: left;
      background:#e8e8e8;
      border-radius: 10px;
      margin-right: 10px;
      img{
        width: 30px;
        float: left;
        margin-left: 20px;
        margin-top: 11px;
      }
      .s_btn{
        width: 15%;
        text-align: center;
        float: left;
        line-height: 50px;
      }
      input{
        background:#e8e8e8;
        border: none;
        float: left;
        margin-left: 20px;
        height: 50px;
        width: 70%;
        outline: none;
      }
      input[type=search] {
        -webkit-appearance: textfield;
        -webkit-box-sizing: content-box;
        font-family: inherit;
        font-size: 100%;
        }
        input::-webkit-search-decoration,
        input::-webkit-search-cancel-button {
        display: none;
        }
    }
    .ss_btn{
      float: left;
      width: 13%;
      text-align: center;
      height: 50px;
      margin-top:15px;
      line-height: 50px;
    }
  }
  .s_history{
    background: #ececec;
    padding: 0 20px;
    overflow: hidden;
    height: calc(100vh - 80px);
    .close{
      display: flex;
      align-items: center;
      height: 40px;
      text-align: center;
      line-height: 40px;
      border-radius: 50%;
      font-size: 28px;
      color: #999;
      // border: 1px solid #ccc;
      // color: #ccc;
      // background: #fff;
      // margin-top: 20px;
      float: right;
    }
    .history_p{
      font-size: 28px;
      font-weight: bolder;
      line-height: 50px;
      margin-top: 30px;
      margin-left: 20px;
    }
    .history_span{
      display: inline-block;
      background: #fff;
      color: #333;

      text-align: center;
      padding: 10px 20px;
      border-radius: 20px;
      margin-right: 20px;
      margin-top: 20px;
    }
  }
}
.search_btn{
  background: #ee2e2e;
  color: #fff;
  border-radius: 6px;
}
.flex_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.go_back {
    float: left;
    width: 68px;
    height: 68px;
    margin-left: 10px;
    margin-top: 6px;
  }
</style>
